<template>
    <div class="page-pc">
        <div class="pcBack"></div>
        <div class="pcBackMask"></div>
        <div class="pcHeader">
            <img src="@/assets/tiantaiLogo.png" class="navLogo">
            <a @click="to('/userAgreement')">用户协议</a>
            <a @click="to('/privacyPolicy')">隐私政策</a>
        </div>
        <div class="content">
            <div class="contentLeft">
                <div class="top">
                    <img src="@/assets/images/logo.png" class="logo" />
                    <div class="topInfo">
                        <p class="topTitle">天台生活</p>
                        <p class="topDesc">等你来发现</p>
                    </div>
                </div>
                <p class="yindaoDesc">本地生活资讯,发现身边好玩的事情</p>

                <img src="@/assets/erweima_pc.png" class="downloadCode" />
                <p class="donwloadDesc">扫码下载</p>
            </div>
            <div class="contentRight">
                <img src="@/assets/images/phone1.png" class="contentRightPhone1" />
                <img src="@/assets/images/phone2.png" class="contentRightPhone2" />
            </div>
        </div>

        <div class="bottom">
            <p class="botoomP">2025 @台州小安科技有限公司</p>
            <span class="beianSpan">浙ICP备2025179184号-1</span>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        to(page){
            this.$router.push(page)
        }
    }
}
</script>
<style scoped>


.pcBack{position:fixed;left:0;top:0;z-index:-100;width:100%;height:100%;background-image:url("@/assets/back1.jpg");background-size:cover}
.pcBackMask{position:fixed;top:0;left:0;width:100%;height:100%;z-index:-100;background:rgba(0,0,0,.85)}
/*导航栏*/
.pcHeader{position:fixed;left:0;top:0;width:100%;height:60px;padding:0 40px;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;background-color:rgba(0,0,0,.75);z-index:222}
.navLogo{width:150px;height:50px}
a{width:56px;height:26px;margin-left:40px;color:#FFF;font-size:14px;font-weight:400;line-height:26px;cursor:pointer}
a:hover{color:#efefef}
/*内容*/
.content{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;gap:40px}
/*左侧引导 */
.contentLeft {width: 400px;}

.top{width: 100%;height: 130px;display: flex;flex-direction: row;justify-content: flex-start;align-items: center;}
.logo{width: 130px;height: 130px;border-radius: 10px;margin-right: 20px;}
.topInfo{flex:1;display:flex;flex-direction:column;justify-content:center;align-items:flex-start}
.topTitle{text-align:center;font-size:40px;line-height:60px;color:#fff;font-weight:500}
.topDesc{font-size:30px;line-height:50px;color:#fff;font-weight:500}

.yindaoDesc{font-size:18px;line-height:60px;text-align:center;color:#fff}
.downloadCode{width:180px;height:180px;margin-top:20px}
.donwloadDesc{font-size:18px;color:#FFF;line-height:40px}
/*右侧截图*/
.contentRight{width:410px;height:400px;position:relative}
.contentRightPhone1{width:200px;height:400px;position:absolute;left:0;top:0;z-index:11}
.contentRightPhone2{width:200px;height:400px;position:absolute;right:0;z-index:11}
/*底部bottom*/
.bottom{position:fixed;width:100%;left:0;bottom:20px}
.botoomP{width:100%;text-align:center;color:#FFF;font-size:11px;line-height:20px;color:#ffffff80}
.beianSpan{font-weight:400;font-size:11px;line-height:150%;cursor:pointer;letter-spacing:2px;color:#ffffff80}
.beianSpan:hover{color:#FFF}
</style>